window.htmx = require("htmx.org");

window.htmx.config.useTemplateFragments = true;
